import { getCache, setCache } from './cache'; // add this line

const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://uropine.ruralsurgery.in';

export const getGistFileContent = async (gistId) => {
  const cacheKey = `gist_${gistId}`;
  const cachedData = getCache(cacheKey);
  if (cachedData) {
    console.log("Loaded file content from cache");
    return cachedData;
  }

  try {
    const response = await fetch(`${BASE_URL}/api/v1/reports/${gistId}`, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Origin': window.location.origin
      },
      mode: 'cors',
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    const fileContent = Object.values(data.data.files)[0].content;
    const parsedContent = [JSON.parse(fileContent)];

    // Set cache for 5 minutes
    setCache(cacheKey, parsedContent, 5);

    console.log("Fetched file content from API");
    return parsedContent;
  } catch (error) {
    console.error("Error fetching gist content:", error.message);
    throw new Error(`Failed to fetch gist content: ${error.message}`);
  }
};

const batchProcess = async (items, batchSize = 5) => {
  const results = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i + 0, i + batchSize);
    const batchResults = await Promise.all(batch);
    results.push(...batchResults);
  }
  return results;
};

export const visualizeAllGists = async () => {
  const cacheKey = 'all_gists';
  const cachedData = getCache(cacheKey);
  if (cachedData) {
    console.log("Loaded all gists from cache");
    return cachedData;
  }

  try {
    console.log('Fetching from:', BASE_URL);

    const response = await fetch(`${BASE_URL}/api/v1/reports`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();

    const fetchPromises = data.data.map((gist) => {
      const firstFile = Object.values(gist.files)[0];
      if (!firstFile.raw_url) {
        console.warn(`No raw_url found for gist: ${gist.id}`);
        return Promise.resolve(null);
      }

      return fetch(firstFile.raw_url)
        .then((response) =>
          response.ok
            ? response.text()
            : Promise.reject(`Failed to fetch: ${response.status}`)
        )
        .then((content) => [JSON.parse(content)])
        .catch((error) => {
          console.warn(`Error processing gist ${gist.id}:`, error);
          return null;
        });
    });

    const gistContents = await batchProcess(fetchPromises);
    const filteredGists = gistContents.filter((content) => content !== null).flat();

    // Set cache for 5 minutes
    setCache(cacheKey, filteredGists, 5);

    console.log("Processed all gists");
    return filteredGists;
  } catch (error) {
    console.error("Error fetching all gists:", error.message);
    throw new Error(`Failed to fetch gists: ${error.message}`);
  }
};
